import axios from 'axios';
import { makeUseAxios } from 'axios-hooks';
import i18n from 'i18n';
import { appToast } from 'utils/toast.utils';
import {
  getItemDisabledErrorMessage,
  KNOWN_RESPONSE_MESSAGES,
  KNOWN_RESPONSE_STATUSES,
} from './const';

export const axiosInstance = axios.create({
  baseURL: `/backend/service`,
  headers: { 'Content-Type': 'application/json' },
});

// * here we can add middlewares, example below:
// axiosInstance.interceptors.request.use(
//   (response) => ({
//     ...response,
//     data: response.data && convertToSnakeCase(response.data, { deep: true }),
//   }),
//   (error) => Promise.reject(error),
// );

axiosInstance.interceptors.response.use((res) => {
  if (res.data.status === 401) {
    window.location = '/login?action=logout' as unknown as Location;
    return res;
  }

  if (res.data.status === 403) {
    appToast.error(i18n.t(`message.accessDenied`, { ns: 'misc' }));
    return res;
  }

  if (res.data.status === undefined) {
    return res;
  }

  if (res.data.status !== 'OK') {
    if ((res.config as any).skipErrorToast) {
      return Promise.reject(res);
    }

    const errStatus = i18n.t(`status.${res.data.status}`, { ns: 'misc' });

    if (i18n.exists(`errors.${res.data.message}`, { ns: 'misc' })) {
      const errMsg = i18n.t(`errors.${res.data.message}`, { ns: 'misc' });

      if (res.data.status === KNOWN_RESPONSE_STATUSES.INTERNAL_SERVER_ERROR) {
        appToast.error(errStatus, errMsg);
      } else if (
        res.data.status === KNOWN_RESPONSE_STATUSES.BAD_REQUEST &&
        res.data.message === KNOWN_RESPONSE_MESSAGES.ITEM_DISABLED
      ) {
        const { type, code } = res.data.result;
        const newErrMsg = getItemDisabledErrorMessage({ type, code });
        appToast.warning(errStatus, newErrMsg);
      } else if (
        res.data.status === KNOWN_RESPONSE_STATUSES.BAD_REQUEST &&
        res.data.message ===
          KNOWN_RESPONSE_MESSAGES.BASE_INVOICE_MISSING_KSEF_NUMBER
      ) {
        appToast.warning(errStatus, res.data.details || errMsg);
      } else {
        appToast.warning(errStatus, errMsg);
      }
    } else {
      appToast.error(
        errStatus,
        i18n.t<string>(`message.contactAdministrator`, { ns: 'misc' }),
      );
    }
  }

  return res;
});

export const useAxios = makeUseAxios({
  axios: axiosInstance,
  defaultOptions: { manual: true },
});
